import {
    ADD_AND_APPLY_FILTER,
    REMOVE_AND_APPLY_FILTER,
    BATCH_ADD_AND_APPLY_FILTER,
    BATCH_REMOVE_AND_APPLY_FILTER,
    CLEAR_FILTERS_BY_NAME,
    TOGGLE_FILTER_DISPLAY,
    ADD_APPLIED_FILTERS,
    TOGGLE_REQUEST_IN_FLIGHT,
    TOGGLE_HASH_FRAGMENT_RESOLVED,
    UPDATE_URI_REF,
    UPDATE_ZIP_CODE,
    SET_SEMANTIC_SEARCH_TERM,
} from '../actions/filterActions';
import { UPDATE_RELAY_VARIABLES } from '../actions/sharedRelayVariableActions';
import UriRefBuilder from 'dibs-generate-uriref';
import { getQueryParam, addCdnQueryParams, hasHashFragment } from '../utils/uriUtils';
import get from 'lodash.get';
let uriRefBuilder;
let initialVariables;

const initUriRefBuilder = options => {
    const { uriRef } = options;

    uriRefBuilder = new UriRefBuilder({ options: { canOutputFragments: hasHashFragment(uriRef) } });
};

/**
 * Used for testing purposes.
 */
export function resetUriRefBuilder() {
    uriRefBuilder = null;
}

function getUriRef() {
    return addCdnQueryParams(uriRefBuilder.getUriRef());
}

function clone(obj) {
    // todo: why do we need to clone these?
    // object spreads should be used to ensure objects are copied deeply without
    return JSON.parse(JSON.stringify(obj));
}

const getPage = generatedUriRef =>
    parseInt(getQueryParam(generatedUriRef, 'page'), 10) ||
    parseInt(getQueryParam(generatedUriRef, 'page', true), 10) ||
    1;

const applyFilters = state => {
    const appliedFilters = clone(uriRefBuilder.getFilters()).filter(({ name }) => name !== 'page');
    // FINDING-12453 - remove page filter when applying new filter
    uriRefBuilder.removeFiltersByName('page');
    return {
        ...state,
        appliedFilters,
        generatedUriRef: getUriRef(),
    };
};

const initialState = {
    isClient: false,
    filtersShown: false,
    appliedFilters: [],
    generatedUriRef: null,
    page: 1,
    refetchInFlight: false,
    isHashFragmentResolved: false,
    additionalFiltersToAdd: [],
    zipCode: '0',
    hasNewFilterUpdates: false,
    semanticSearchTerm: '',
    hasCheckedForSemanticSearchTerm: false,
};

export function filterReducer(state = initialState, action) {
    const { type, payload } = action;
    if (!uriRefBuilder && state.isClient) {
        initUriRefBuilder({ uriRef: state.generatedUriRef });
    }

    // if a request is in flight, the state is temporarily locked until it completes :
    if (state.refetchInFlight && type !== TOGGLE_REQUEST_IN_FLIGHT) {
        return state;
    }

    switch (type) {
        case UPDATE_RELAY_VARIABLES:
            return { ...state, ...{ isClient: get(action, 'variables.isClient') } };

        case TOGGLE_REQUEST_IN_FLIGHT:
            return { ...state, refetchInFlight: payload, hasNewFilterUpdates: true };

        case TOGGLE_HASH_FRAGMENT_RESOLVED:
            return { ...state, ...{ isHashFragmentResolved: payload } };

        case ADD_APPLIED_FILTERS: {
            initUriRefBuilder({ uriRef: state.generatedUriRef });
            initialVariables = payload;
            uriRefBuilder.addFilters(initialVariables);
            const generatedUriRef = getUriRef();
            return {
                ...state,
                generatedUriRef,
                page: getPage(generatedUriRef),
                appliedFilters: uriRefBuilder.getFilters(),
            };
        }

        case UPDATE_ZIP_CODE: {
            return { ...state, ...{ zipCode: payload } };
        }

        case TOGGLE_FILTER_DISPLAY: {
            const filtersShown =
                typeof action.filtersShown === 'boolean'
                    ? action.filtersShown
                    : !state.filtersShown;
            return { ...state, filtersShown, hasNewFilterUpdates: false };
        }

        case BATCH_ADD_AND_APPLY_FILTER:
            uriRefBuilder.addFilters([{ name: payload.filterName, values: payload.filterValues }]);
            return applyFilters(state, payload);

        case BATCH_REMOVE_AND_APPLY_FILTER:
            payload.filterNames.forEach(name => uriRefBuilder.removeFiltersByName(name));
            return applyFilters(state);

        case ADD_AND_APPLY_FILTER:
            uriRefBuilder.addFilter(payload.filterName, payload.filterValue);
            return applyFilters(state, payload);

        case REMOVE_AND_APPLY_FILTER:
            uriRefBuilder.removeFilter(payload.filterName, payload.filterValue);
            return applyFilters(state, payload);

        case CLEAR_FILTERS_BY_NAME:
            uriRefBuilder.removeFiltersByName(payload);
            return {
                ...state,
                appliedFilters: clone(uriRefBuilder.getFilters()),
            };

        case UPDATE_URI_REF: {
            const newUriRef = payload ? addCdnQueryParams(payload) : getUriRef();
            return {
                ...state,
                appliedFilters: [],
                generatedUriRef: newUriRef,
                page: getPage(newUriRef),
            };
        }

        case SET_SEMANTIC_SEARCH_TERM: {
            return {
                ...state,
                semanticSearchTerm: payload,
                hasCheckedForSemanticSearchTerm: true,
            };
        }

        default:
            return state;
    }
}
